export default __webpack_public_path__ + "static/illo-privacy-409222f63a2d54f09caf1002296b683c.svg";